import { CompanyPartTimeMaxCountPerDayOption } from '~/models/types';

const samplePatterns: string[] = [
  '500人/日〜',
  '250〜499人/日',
  '75〜249人/日',
  '15〜74人/日',
  '5〜14名/日',
  '4名/日以下',
];

const all: CompanyPartTimeMaxCountPerDayOption[] = samplePatterns.map((value, idx) => ({
  masterCompanyPartTimeMaxCountPerDayId: idx,
  label: value,
}));

export const companyPartTimeMaxCountPerDayOption = (
  pattern: number
): CompanyPartTimeMaxCountPerDayOption => all[pattern % all.length];

companyPartTimeMaxCountPerDayOption.all = all;
